import { render, staticRenderFns } from "./newService.vue?vue&type=template&id=0dd0c94a&scoped=true"
import script from "./newService.vue?vue&type=script&lang=js"
export * from "./newService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd0c94a",
  null
  
)

export default component.exports